import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import moment from 'moment';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { querySelector } from '../../../utils';

import { LeaseInputLeaseFragment } from '../LeaseInput';
import { OperatorInputOperatorFragment } from '../OperatorInput';

/* eslint-disable */
const propTypes = {
  jobNumbers: PropTypes.array.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
/* eslint-enable */

const JobInput = (props) => {
  const { jobNumbers, value, onChange } = props;
  return (
    <div>
      <InputGroup>
        <DropdownList
          inputProps={{
            className: 'form-control',
          }}
          filter="contains"
          allowCreate="onFilter"
          value={value}
          data={jobNumbers}
          onChange={onChange}
          valueField="id"
          textField="job_number"
        />
        <InputGroup.Button>
          <Button
            name="cancel"
            disabled={!value}
            onClick={() => { onChange(null); }}
          >
            <Glyphicon glyph="remove" />
          </Button>
        </InputGroup.Button>
      </InputGroup>
    </div>
  );
};


const GetAllJobNumbersQuery = gql`
  query GetAllJobNumbers($state: JobStateTypes!, $newer_than: String!) {
    all_jobs(state: $state, newer_than: $newer_than) {
      edges {
        node {
          id
          job_number
          lease {
            id
            lookup {
              ...LeaseInputLease
            }
            operator {
              id
              lookup {
                ...OperatorInputOperatorLookup
              }
            }
          }
        }
      }
    }
  }
  ${LeaseInputLeaseFragment}
  ${OperatorInputOperatorFragment}
`;

const queryVariables = () => {
  const state = 'unreviewed';
  return {
    fetchPolicy: 'network-only',
    variables: {
      state,
      newer_than: moment().subtract(2, 'month').format('YYYY/MM/DD'),
    },
  };
};


export const marshallData = ({ data, ownProps }) => {
  const jobNumbers = querySelector(data, '$.all_jobs.edges[*].node', []);
  return {
    ...ownProps,
    data,
    jobNumbers,
  };
};


JobInput.propTypes = propTypes;
const withData = graphql(GetAllJobNumbersQuery, { props: marshallData, options: queryVariables });

export default withData(JobInput);
